/**
 * Phased scheduler (homepage). Tasks run on independent timers — not serialized
 * (serial Promise chains stalled Lighthouse and delayed LCP).
 */
(function (w) {
  var isIndex = document.body && document.body.classList.contains('template-index');
  var isProduct = document.body && document.body.classList.contains('template-product');
  var phased = isIndex || isProduct;

  var phases = {
    ui: { delay: 80 },
    deferred: { delay: 1400 },
    below: { delay: 2600 },
    analytics: { delay: 5200 }
  };

  if (w.matchMedia && w.matchMedia('(min-width: 769px)').matches) {
    phases = {
      ui: { delay: 50 },
      deferred: { delay: 900 },
      below: { delay: 1800 },
      analytics: { delay: 4200 }
    };
  }

  if (isProduct) {
    phases = {
      ui: { delay: 60 },
      deferred: { delay: 1100 },
      below: { delay: 2200 },
      analytics: { delay: 3800 }
    };
  }

  w.tswSchedule = function (fn, phase, delayOffset) {
    if (!phased) {
      fn();
      return;
    }
    var p = phases[phase] || phases.deferred;
    w.setTimeout(fn, p.delay + (delayOffset || 0));
  };
})(window);
